<template>
	<div>
		<categories-selector
			:categories="categories"
			:display="display"
			:show-all="showAll"
			@on-switch-change="onSwitchChange"
			@selected-all="selectedAll"
			@selected-category="selectedCategory"
		></categories-selector>
		<template v-if="displayMap">
			<div class="container-map">
				<map-view :url-image="mapImage"></map-view>
			</div>
		</template>
		<template v-else>
			<list-view
				:categories="categories"
				:category="categorySelected"
				:show-all="showAll"
				@visit-store="visitStore"
			></list-view>
		</template>
		<v-dialog
			content-class="dialog-market-place"
			v-model="dialogValue"
			persistent
			:max-width="maxWidth"
		>
			<v-card>
				<modal-information
					:address="address"
					:address-location="addressLocation"
					:alias="alias"
					:country-code="userData.countryCode"
					:loading-location="loadingLocation"
					:location-inactive="locationInactive"
					:settings="{ center: location, height, markers, unitHeight, unitWidth, width, zoom }"
					@active-location="activeLocation"
					@change-location="changeLocation"
					@get-address="setAddress"
					@get-data="setData"
					@on-center-changed="onCenterChanged"
					@save-location="saveLocation"
				></modal-information>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import categoriesSelector from '@/components/market-place/categories-selector';
	import listView from '@/components/market-place/list-view';
	import gmapComponent from '@/components/shared/gmap-component';
	import helper from '@/shared/helper';
	import mapView from '@/components/market-place/map-view';
	import modalInformation from '@/components/market-place/modal-information';

	const { debounce } = helper;

	function created() {
		const body = document.getElementById('body');
		body.className = 'body-pac-marketplace';
		const localData = localStorage.getItem('casamarket::location-data');
		if (localData) {
			({
				addressLocation: this.addressLocation,
				address: this.address,
				alias: this.alias,
				latitude: this.latitude,
				longitude: this.longitude,
			} = JSON.parse(localData));
			this.location = { lat: this.latitude, lng: this.longitude };
			this.dialog = false;
			this.locationInactive = false;
			this.setLocalAddress();
		}
		this.onOpenLocationModal();
		this.loadData();
	}

	function activeLocation() {
		this.loadingLocation = true;
		window.navigator.geolocation.getCurrentPosition((location) => {
			this.location = { lat: location.coords.latitude, lng: location.coords.longitude };
		});
	}

	function changeLocation() {
		this.locationInactive = true;
		this.addressLocation = '';
	}

	function displayMap() {
		return this.display === 1;
	}

	async function loadData() {
		const localIpData = localStorage.getItem('casamarket::ip-data');
		const parseData = JSON.parse(localIpData);
		if (parseData && parseData.countryCode) {
			this.userData = { ...parseData };
		} else {
			({ data: this.userData } = await this.$httpApi.get('ip-api'));
			const ipData = JSON.stringify(this.userData);
			localStorage.setItem('casamarket::ip-data', ipData);
		}
		this.categories = this.categories.map((category) => {
			const newCategory = { ...category };
			const stores = this.commerce.filter(c => c.itemId === category.id);
			newCategory.selected = false;
			newCategory.icon = '';
			newCategory.height = 35;
			newCategory.stores = stores.map((store) => {
				const newStore = { ...store };
				newStore.category = { ...category };
				return newStore;
			});
			return newCategory;
		});
		this.loadLocations();
	}

	function loadLocations() {
		const height = window.innerHeight - 275;
		const width = window.innerWidth;
		const baseUrl = 'https://maps.googleapis.com/maps/api/staticmap';
		const markers = this.commerce.reduce((a, c) => {
			let newA = '';
			const newC = `icon:https://casamarket-landing.netlify.app/static/images-new/icons/icon-marker-green.png|${c.latitude},${c.longitude}`;
			if (a.length > 0) {
				newA = a.concat(`&markers=${newC}`);
			} else {
				newA = a.concat(newC);
			}
			return newA;
		}, '');
		const params = {
			center: `${this.commerce[0].latitude},${this.commerce[0].longitude}`,
			format: 'gif',
			key: process.env.GOOGLE_MAP_KEY,
			markers,
			maptype: 'roadmap',
			saturation: -100,
			scale: 1,
			size: `${width}x${height}`,
			zoom: 10,
		};
		this.mapImage = `${baseUrl}?center=${params.center}&markers=${params.markers}&maptype=${params.maptype}&size=${params.size}&zoom=${params.zoom}&key=${params.key}&scale=${params.scale}&format=${params.format}&style=saturation:${params.saturation}`;
	}

	function locationInactive(value) {
		const body = document.getElementById('body');
		body.className = value ? 'body-pac-marketplace' : 'body-pac';
	}

	function onCenterChanged(value) {
		const { latLng } = value;
		this.isChanged = true;
		this.location.lat = latLng ? latLng.lat() : value.lat();
		this.location.lng = latLng ? latLng.lng() : value.lng();
		this.latitude = this.location.lat;
		this.longitude = this.location.lng;
	}

	function onSwitchChange({ model, value }) {
		this[model] = value;
	}

	function saveLocation() {
		const locationData = {
			addressLocation: this.addressLocation,
			address: this.address,
			alias: this.alias,
			latitude: this.latitude,
			longitude: this.longitude,
		};
		const localLocationData = JSON.stringify(locationData);
		localStorage.setItem('casamarket::location-data', localLocationData);
		this.locationInactive = true;
		this.dialog = false;
		this.openLocationModal(false);
		this.setLocalAddress();
	}

	function selectedAll() {
		this.categories = this.categories.map((c) => {
			const newCategory = { ...c };
			newCategory.selected = false;
			return newCategory;
		});
		this.showAll = true;
	}

	function selectedCategory({ id }) {
		this.showAll = false;
		this.categories = this.categories.map((c) => {
			const newCategory = { ...c };
			newCategory.selected = c.id === id;
			return newCategory;
		});
		this.categorySelected = this.categories.find(c => c.selected);
	}

	function setAddress() {
		const input = document.getElementById('input-autocomplete-marketplace');
		const autocomplete = new window.google.maps.places.Autocomplete(
			input,
			{
				types: ['geocode'],
			},
		);
		autocomplete.addListener('place_changed', () => {
			const place = autocomplete.getPlace();
			this.location = {
				lat: place.geometry.location.lat(),
				lng: place.geometry.location.lng(),
			};
			this.markers[0].position.lat = this.location.lat;
			this.markers[0].position.lng = this.location.lng;
			this.latitude = this.location.lat;
			this.longitude = this.location.lng;
		});
		this.address = '';
	}

	function setData({ model, value }) {
		this[model] = value;
	}

	function setLocation() {
		const latLng = { lat: parseFloat(this.location.lat), lng: parseFloat(this.location.lng) };
		const geocoder = new window.google.maps.Geocoder();
		if (this.locationInactive) {
			this.markers[0].position.lat = this.location.lat;
			this.markers[0].position.lng = this.location.lng;
			this.latitude = this.markers[0].position.lat;
			this.longitude = this.markers[0].position.lng;
		}
		geocoder.geocode({ location: latLng }, (results, status) => {
			if (status === 'OK') {
				if (results[0]) {
					this.addressLocation = results[0].formatted_address;
					this.zoom = 18;
				}
			}
		});
		this.locationInactive = false;
		this.loadingLocation = false;
	}

	function visitStore({ name, tokenStore }) {
		localStorage.setItem('casamarket::commerce-token', tokenStore);
		this.goTo('commerce-home', { params: { slug: name } });
	}

	function watchLocation(value) {
		const storageLocation = localStorage.getItem('casamarket::location-data');
		const validation = !storageLocation || this.isChanged;
		if (value.lat && value.lng && validation) {
			this.setLocation();
		} else {
			this.loadingLocation = false;
		}
	}

	function dialogValue() {
		return this.dialog || this.openValue;
	}

	function data() {
		return {
			address: '',
			addressLocation: '',
			alias: '',
			categories: [
				{
					id: 7,
					name: 'Carnicería',
					totalCommerce: 0,
				},
				{
					id: 8,
					name: 'Bodega Minimarket',
					totalCommerce: 0,
				},
				{
					id: 41,
					name: 'Frutería',
					totalCommerce: 0,
				},
				{
					id: 42,
					name: 'Abarrotes',
					totalCommerce: 0,
				},
				{
					id: 43,
					name: 'Verduras',
					totalCommerce: 0,
				},
				{
					id: 44,
					name: 'Dulcerías',
					totalCommerce: 0,
				},
			],
			categorySelected: {},
			center: {
				lat: -0.1764507,
				lng: -78.47527600000001,
			},
			commerce: [
				{
					tokenStore: '$2y$10$t2hAH.h79pj1bTvfz9wMouLGmmlXwxx4PN/FNlETtQsTggvxX1lyi',
					id: 8,
					code: 'mistore',
					name: 'mistore',
					rzSocial: 'Mi store',
					documentNumber: null,
					location: {
						x: -0.2705519,
						y: -79.1588467,
					},
					email: 'soporte@apprunn.com',
					phone: '01445585',
					address: 'santo domingo, calle cotoplaxi 121',
					urlImage: 'https://japi-static.s3.amazonaws.com/taurus/youtube.jpg',
					socialNetworks: [
						{
							link: 'https://www.facebook.com',
							logo: 'https://japi-static.s3.amazonaws.com/taurus/facebook-770688_960_720.png',
						},
						{
							link: 'https://www.twitter.com',
							logo: 'https://japi-static.s3.amazonaws.com/taurus/Logo-Twitter.png',
						},
					],
					aclCode: null,
					templateId: null,
					settings: {
						hash: '$2y$10$t2hAH.h79pj1bTvfz9wMouLGmmlXwxx4PN/FNlETtQsTggvxX1lyi',
						theme: {
							id: 1,
							name: 'themeOne',
							image: 'https://japi-static.s3.amazonaws.com/japi-sales-error/QTC_Home-Copy.jpg',
							title: '#4D4D4D',
							border: '#F3F3F3',
							primary: '#FF6600',
							subTitle: '#999999',
							secondary: '#2C404A',
							themesCode: 'themesCode',
						},
						template: {
							id: 7743,
							code: 'TEMP',
							name: 'TEMPLATE 2',
							value: null,
							amount: 0,
							number: 0,
							flagIece: 0,
							flagRole: null,
							flagEmpty: null,
							flagSecap: 0,
							generalId: null,
							flagActive: 1,
							typeFormat: null,
							description: 'El registro de template obtendra internamente los colores',
							observation: null,
							referenceId: null,
							typeGeneral: {
								id: 44,
								code: 'TEMP',
								name: 'TEMPLATE',
								countryId: null,
								flagCompany: 0,
							},
							areasCompany: null,
							flagDiscount: 0,
							typeEntityId: null,
							typeGeneralId: 44,
							financialEntity: null,
							aditionalInformation: {
								themes: [
									{
										id: 1,
										name: 'themeOne',
										image: 'https://japi-static.s3.amazonaws.com/japi-sales-error/QTC_Home-Copy.jpg',
										title: '#4D4D4D',
										border: '#F3F3F3',
										primary: '#FF6600',
										subTitle: '#999999',
										secondary: '#2C404A',
										themesCode: 'themesCode',
									},
									{
										id: 2,
										name: 'themeTwo',
										image: 'https://japi-static.s3.amazonaws.com/japi-sales-error/template-1-home-solintha.jpg',
										title: '#FF133B',
										border: '#E4E4E4',
										primary: '#FF2449',
										subTitle: '#4A4A4A',
										secondary: '#505AA5',
										themesCode: 'themesCode',
									},
									{
										id: 3,
										name: 'themeThree',
										image: 'https://japi-static.s3.amazonaws.com/japi-sales-error/template-1-home-merkato.jpg',
										title: '#4A4A4A',
										border: '#E4E4E4',
										primary: '#F42B17',
										subTitle: '#777777',
										secondary: '#004E9C',
										themesCode: 'themesCode',
									},
									{
										id: 4,
										name: 'themeFour',
										image: 'https://japi-static.s3.amazonaws.com/japi-sales-error/template-1-home-gogammer.jpg',
										title: '#272727',
										border: '#E4E4E4',
										primary: '#E30517',
										subTitle: '#5D5D5D',
										secondary: '#C10010',
										themesCode: 'themesCode',
									},
									{
										id: 5,
										name: 'themeFive',
										image: 'https://japi-static.s3.amazonaws.com/japi-sales-error/template-1-home-wawabox.jpg',
										title: '#3AAEE2',
										border: '#E4E4E4',
										primary: '#EC62A3',
										subTitle: '#464646',
										secondary: '#D12F7E',
										themesCode: 'themesCode',
									},
								],
								urlImage: 'https://japi-static.s3.amazonaws.com/japi-sales-error/Template1-mo%CC%81vil_gogammer.png',
								flagDefault: 1,
							},
						},
						codeTaxes: 444,
						limitHome: 10,
						flagBilling: false,
						serviceCost: 10,
						shippingCost: 15,
						limitShownHome: 15,
						salPriceListId: 152,
						defaultWarehouse: {
							id: 522,
							code: '099',
							name: 'REVISION QUIPU',
							phone: null,
							isMain: 0,
							address: 'AMBATO',
							latitude: null,
							location: null,
							settings: null,
							codeTaxes: null,
							companyId: 489,
							createdAt: '2018-12-18T21:22:42.000Z',
							longitude: null,
							updatedAt: '2018-12-18T21:22:42.000Z',
							flagActive: 1,
							subsidiary: {
								id: 144,
								ruc: '0501662316001',
								rise: null,
								email: 'tania@quipu.com',
								phone: '987456321',
								ubigeo: '1093',
								address: 'COTOPAXI / LATACUNGA / LA MATRIZ / AV. UNIDAD NACIONAL S/N Y GABRIELA MISTRAL',
								rucName: '0501662316001 - ADS ASESORIA Y DESARROLLO DE SISTEMAS DE INFORMACION',
								urlLogo: null,
								location: {
									x: -12.0460631,
									y: -77.0401732,
								},
								rzSocial: 'ANCHATUÑA CHANGO JORGE RODRIGO',
								settings: {
									allowProductFree: false,
								},
								urlImage: '/sucursal.png',
								companyId: 489,
								flagTaxes: 1,
								debtsSales: {
									PEN: -35294.87996,
									USD: 42970.96999999997,
								},
								districtId: null,
								provinceId: null,
								contactName: 'Tania',
								flagAccount: 0,
								departmentId: null,
								subsidiaryId: null,
								sucursalCode: 'SUCQUIPU',
								sucursalName: 'ADS ASESORIA Y DESARROLLO DE SISTEMAS DE INFORMACION',
								typeAmbientTax: 1,
								contactLastname: 'Zambrano',
								flagCreditDispatch: null,
								specialContributor: null,
								websiteDescription: [],
								flagAccountingEngine: 0,
								distributorCustomerId: null,
								flagAccountingAutomatic: 0,
							},
							externalCode: null,
							subsidiaryId: 144,
							flagEcommerce: 0,
						},
						enablePushNotification: true,
					},
					employeeId: 312,
					subsidiaryId: 144,
					warehousesRelated: [
						648,
						649,
						711,
						523,
					],
					wayPaymentRelated: [
						3,
						1,
					],
					bankAccountsRelated: [],
					urlDomain: 'https://ecommerce-template.netlify.com',
					metadata: null,
					templateCode: null,
					colorCode: null,
					favicon: {
						value: 'https://japi-static.s3.amazonaws.com/taurus/mi-store-peru.svg',
					},
					urlQr: 'https://japi-static.s3.amazonaws.com/taurus/QRc%C3%B3digo_portada_wikipedia_espa%C3%B1ol.png',
					whatsappNumber: '981282982',
					flagActive: 1,
					scriptChat: null,
					deliveryType: [
						{
							id: 7769,
							code: 'RCT',
							name: 'Recojo en Tienda',
						},
						{
							id: 7770,
							code: 'EAD',
							name: 'Envio a Domicilio',
						},
					],
					itemId: 7,
					promotionSettings: null,
					latitude: -0.2705519,
					longitude: -79.1588467,
					helperCenter: [
						{
							id: 77,
							name: 'hola',
							subTitle: 'mundo',
							description: 'mundo',
							orderNumber: 5,
							urlImage: null,
							comCommerceInformationId: null,
							comCommerceId: 8,
							typeHelperCenter: 7744,
							flagActive: 1,
							section: [
								{
									id: 7744,
									name: 'Información',
									code: 'THC',
									description: null,
									observation: null,
									typeEntityId: null,
									typeGeneralId: 45,
									number: 0,
									value: null,
									flagDiscount: 0,
									amount: 0,
									generalId: null,
									referenceId: null,
									flagSecap: 0,
									flagIece: 0,
									flagEmpty: null,
									flagRole: null,
									flagActive: 1,
									aditionalInformation: null,
								},
							],
							mainName: 'hola',
						},
						{
							id: 78,
							name: '3432',
							subTitle: '2342',
							description: '234',
							orderNumber: 3,
							urlImage: null,
							comCommerceInformationId: null,
							comCommerceId: 8,
							typeHelperCenter: 7744,
							flagActive: 1,
							section: [
								{
									id: 7744,
									name: 'Información',
									code: 'THC',
									description: null,
									observation: null,
									typeEntityId: null,
									typeGeneralId: 45,
									number: 0,
									value: null,
									flagDiscount: 0,
									amount: 0,
									generalId: null,
									referenceId: null,
									flagSecap: 0,
									flagIece: 0,
									flagEmpty: null,
									flagRole: null,
									flagActive: 1,
									aditionalInformation: null,
								},
							],
							mainName: '3432',
						},
					],
					wayPaymentCommerce: [
						{
							commerceId: 8,
							wayPaymentId: 3,
							description: null,
							gatewayConfiguration: [],
							wayPayment: {
								id: 3,
								name: 'Deposito Bancario',
								code: 'IBD',
								description: 'Deposito Bancario',
								countryId: 1,
								gatewayConfiguration: [
									{
										code: 'visa',
										name: 'Agente',
									},
									{
										code: 'paymentez',
										name: 'Yape',
									},
									{
										code: 'paymentez',
										name: 'Lukita',
									},
								],
							},
						},
						{
							commerceId: 8,
							wayPaymentId: 1,
							description: null,
							gatewayConfiguration: [],
							wayPayment: {
								id: 1,
								name: 'Tarjeta de crédito o débito',
								code: 'CDC',
								description: 'Tarjeta de crédito o débito',
								countryId: 1,
								gatewayConfiguration: [
									{
										code: 'visa',
										name: 'visaNet',
										fields: [
											{
												name: 'merchantId',
												input: 'text',
												placeholder: 'Commerce ID*',
											},
											{
												name: 'accessKey',
												input: 'text',
												placeholder: 'Key*',
											},
											{
												name: 'accessUser',
												input: 'text',
												placeholder: 'Client ID*',
											},
										],
									},
								],
							},
						},
					],
					terminals: {
						id: 348,
						comSubsidiariesId: 144,
						warWarehousesId: null,
						warWarehousesName: 'Tienda ecommerce',
						salTypeTerminalsId: 2,
						typeTerminal: 1,
						name: 'TIENDA virtual QUIPU-ADS ASESORIA Y DESARROLLO DE SISTEMAS DE INFORMACION',
						description: 'TIENDA virtual QUIPU-SUC QUIPU',
						code: 'TMNQUIPUE',
						sunatCode: '',
						printCode: '',
						ruc: null,
						cashId: 145,
						authorizationDate: null,
						codeTaxes: null,
						flagActive: 1,
						flagEcommerce: 0,
						typeDevice: null,
						sessionStatusId: 2,
						commerceId: 8,
						sessionStatusName: 'Ocupado',
					},
				},
				{
					tokenStore: null,
					id: 18,
					code: 'GAM-34',
					name: 'GAMERS',
					rzSocial: 'GAMERS SAC',
					documentNumber: '2044444444333',
					location: null,
					email: 'MICORREO@MAIL.COM',
					phone: '+51 999 444 3333',
					address: 'ESTA ES LA DIRECCION',
					urlImage: 'https://japi-static.s3.amazonaws.com/undefined/gatorade-y-sams-gana-kit-de-productos.jpg',
					socialNetworks: [],
					aclCode: null,
					templateId: null,
					settings: {
						theme: {},
						template: {},
						codeTaxes: 123,
						limitHome: 8,
						flagBilling: false,
						serviceCost: 0.8,
						shippingCost: 20,
						limitShownHome: 100,
						salPriceListId: 152,
						defaultWarehouse: {
							id: 524,
							code: 'TESTTNDTBS',
							name: 'TEST TIENDA',
							phone: null,
							isMain: 0,
							address: 'TEST DIRECTION',
							latitude: null,
							location: null,
							settings: null,
							codeTaxes: '0557',
							companyId: 489,
							createdAt: '2018-12-20T17:40:48.000Z',
							longitude: null,
							updatedAt: '2018-12-20T17:40:48.000Z',
							flagActive: 1,
							subsidiary: {
								id: 144,
								ruc: '0501662316001',
								rise: null,
								email: 'tania@quipu.com',
								phone: '987456321',
								ubigeo: 1093,
								address: 'COTOPAXI / LATACUNGA / LA MATRIZ / AV. UNIDAD NACIONAL S/N Y GABRIELA MISTRAL',
								rucName: '0501662316001 - ADS ASESORIA Y DESARROLLO DE SISTEMAS DE INFORMACION',
								urlLogo: null,
								location: {
									x: -12.0460631,
									y: -77.0401732,
								},
								rzSocial: 'ANCHATUÑA CHANGO JORGE RODRIGO',
								settings: {
									allowProductFree: false,
								},
								urlImage: '/sucursal.png',
								companyId: 489,
								flagTaxes: 1,
								debtsSales: {
									PEN: -35294.87996,
									USD: 42970.96999999997,
								},
								districtId: null,
								provinceId: null,
								contactName: 'Tania',
								flagAccount: 0,
								departmentId: null,
								subsidiaryId: null,
								sucursalCode: 'SUCQUIPU',
								sucursalName: 'ADS ASESORIA Y DESARROLLO DE SISTEMAS DE INFORMACION',
								typeAmbientTax: 1,
								contactLastname: 'Zambrano',
								flagCreditDispatch: null,
								specialContributor: null,
								websiteDescription: [],
								flagAccountingEngine: 0,
								distributorCustomerId: null,
								flagAccountingAutomatic: 0,
							},
							externalCode: null,
							subsidiaryId: 144,
							flagEcommerce: 0,
						},
						enablePushNotification: true,
					},
					employeeId: null,
					subsidiaryId: 256,
					warehousesRelated: [779, 777],
					wayPaymentRelated: [7, 8],
					bankAccountsRelated: [
						{
							id: 34,
							bank: {
								id: 7,
								code: 'BANPI',
								name: 'BANCO PICHINCHA',
								countryId: 2,
								description: 'BANCO PICHINCHA',
							},
							city: null,
							name: 'CUENTA PRUEBA X11',
							bankId: 7,
							cityId: null,
							balance: 22203.15,
							currency: 'USD',
							disabled: 1,
							updatedAt: '2020-04-30T22:41:18.000Z',
							cutoffDate: '0000-00-00 00:00:00',
							flagActive: 1,
							subsidiaries: null,
							subsidiaryId: null,
							accountNumber: '1478523647',
							currencySymbol: '$',
							initialBalance: 100,
							accountNumberCi: '',
							bankAccountType: {
								id: 1,
								code: 'CC',
								name: 'Cuenta Corriente',
								description: 'Cuenta Corriente',
							},
							fullBankAccount: 'BANCO PICHINCHA | CUENTA PRUEBA X11 | 1478523647',
							flagFormatCharge: 0,
							accountingAccount: '111104',
							bankAccountTypeId: 1,
						},
						{
							id: 50,
							bank: {
								id: 7,
								code: 'BANPI',
								name: 'BANCO PICHINCHA',
								countryId: 2,
								description: 'BANCO PICHINCHA',
							},
							city: null,
							name: 'JAQUIPU BANK',
							bankId: 7,
							cityId: null,
							balance: 109226.42,
							currency: 'USD',
							disabled: 1,
							updatedAt: '2020-04-30T22:41:18.000Z',
							cutoffDate: '2019-02-11T00:00:00.000Z',
							flagActive: 1,
							subsidiaries: null,
							subsidiaryId: null,
							accountNumber: 87458754785,
							currencySymbol: '$',
							initialBalance: 0,
							accountNumberCi: '',
							bankAccountType: {
								id: 2,
								code: 'CR',
								name: 'Cuenta Ahorro',
								description: 'Cuenta Ahorro',
							},
							fullBankAccount: 'BANCO PICHINCHA | JAQUIPU BANK | 87458754785',
							flagFormatCharge: 0,
							accountingAccount: '111101',
							bankAccountTypeId: 2,
						},
					],
					urlDomain: null,
					metadata: {},
					templateCode: null,
					colorCode: null,
					favicon: {
						value: 'https://japi-static.s3.amazonaws.com/undefined/healthy-food.png',
					},
					urlQr: null,
					whatsappNumber: '999888777',
					flagActive: 1,
					scriptChat: null,
					deliveryType: [
						{
							id: 7769,
							code: 'RCT',
							name: 'Recojo en Tienda',
						},
						{
							id: 7770,
							code: 'EAD',
							name: 'Envio a Domicilio',
						},
					],
					itemId: 8,
					promotionSettings: null,
					latitude: null,
					longitude: null,
					helperCenter: [],
					wayPaymentCommerce: [
						{
							commerceId: 18,
							wayPaymentId: 7,
							description: null,
							gatewayConfiguration: [],
							wayPayment: {
								id: 7,
								name: 'Tarjeta de crédito o débito',
								code: 'CDC',
								description: 'Tarjeta de crédito o débito',
								countryId: 2,
								gatewayConfiguration: [
									{
										code: 'visa',
										name: 'visaNet',
										fields: [
											{
												name: 'merchantId',
												input: 'text',
												placeholder: 'Commerce ID*',
											},
											{
												name: 'accessKey',
												input: 'text',
												placeholder: 'Key*',
											},
											{
												name: 'accessUser',
												input: 'text',
												placeholder: 'Client ID*',
											},
										],
									},
									{
										code: 'dataweb',
										name: 'Datafast',
										fields: [
											{
												name: 'authorization',
												input: 'text',
												placeholder: 'Crenciales DataFast*',
											},
											{
												name: 'entityId',
												input: 'text',
												placeholder: 'Conexion ID*',
											},
											{
												name: 'mid',
												input: 'text',
												placeholder: 'Commerce ID*',
											},
											{
												name: 'tip',
												input: 'text',
												placeholder: 'Terminal ID*',
											},
											{
												name: 'testMode',
												input: 'checkbox',
												value: 'EXTERNAL',
												placeholder: 'Entorno de Prueba => EXTERNAL',
											},
										],
									},
									{
										code: 'paymentez',
										name: 'Paymentez',
										fields: [
											{
												name: 'clientAppCode',
												input: 'text',
												placeholder: 'Client code App*',
											},
											{
												name: 'clientAppKey',
												input: 'text',
												placeholder: 'Client app Key*',
											},
										],
									},
								],
							},
						},
						{
							commerceId: 18,
							wayPaymentId: 8,
							description: null,
							gatewayConfiguration: [],
							wayPayment: {
								id: 8,
								name: 'Paga tu producto al recibir',
								code: 'PPR',
								description: 'Paga tu producto al recibir',
								countryId: 2,
								gatewayConfiguration: null,
							},
						},
					],
					terminals: {
						id: 380,
						comSubsidiariesId: 256,
						warWarehousesId: null,
						warWarehousesName: null,
						salTypeTerminalsId: 2,
						typeTerminal: null,
						name: 'GAMERS',
						description: null,
						code: 'GAM-34',
						sunatCode: null,
						printCode: null,
						ruc: null,
						cashId: null,
						authorizationDate: null,
						codeTaxes: null,
						flagActive: 1,
						flagEcommerce: 1,
						typeDevice: null,
						sessionStatusId: 1,
						commerceId: 18,
						sessionStatusName: 'Disponible',
					},
				},
			],
			commerceByItem: [],
			countryCode: '',
			dialog: true,
			display: 1,
			height: 100,
			isChanged: false,
			latitude: 0,
			longitude: 0,
			loadingLocation: false,
			location: {
				lat: 0,
				lng: 0,
			},
			locationInactive: true,
			mapImage: '',
			markers: [
				{
					position: {
						lat: 0,
						lng: 0,
					},
					icon: '/static/images-new/icons/marker-casa-market.png',
				},
			],
			maxWidth: 899,
			showAll: true,
			stores: [
				{
					id: 1,
					address: 'Av. Abancay 456 Cercado de Lima',
					category: {
						id: 1,
						label: 'Abarrotes',
					},
					distance: '3km',
					logo: '/static/images-new/logos/logo-store-default.png',
					name: 'Abarrotes Juanita',
				},
				{
					id: 2,
					address: 'Av. Abancay 456 Cercado de Lima',
					category: {
						id: 1,
						label: 'Abarrotes',
					},
					distance: '3km',
					logo: '/static/images-new/logos/logo-store-default.png',
					name: 'Abarrotes Juanita',
				},
				{
					id: 3,
					address: 'Av. Abancay 456 Cercado de Lima',
					category: {
						id: 1,
						label: 'Abarrotes',
					},
					distance: '3km',
					logo: '/static/images-new/logos/logo-store-default.png',
					name: 'Abarrotes Juanita',
				},
				{
					id: 4,
					address: 'Av. Abancay 456 Cercado de Lima',
					category: {
						id: 1,
						label: 'Abarrotes',
					},
					distance: '3km',
					logo: '/static/images-new/logos/logo-store-default.png',
					name: 'Abarrotes Juanita',
				},
				{
					id: 5,
					address: 'Av. Abancay 456 Cercado de Lima',
					category: {
						id: 1,
						label: 'Abarrotes',
					},
					distance: '3km',
					logo: '/static/images-new/logos/logo-store-default.png',
					name: 'Abarrotes Juanita',
				},
				{
					id: 6,
					address: 'Av. Abancay 456 Cercado de Lima',
					category: {
						id: 1,
						label: 'Abarrotes',
					},
					distance: '3km',
					logo: '/static/images-new/logos/logo-store-default.png',
					name: 'Abarrotes Juanita',
				},
				{
					id: 7,
					address: 'Av. Abancay 456 Cercado de Lima',
					category: {
						id: 1,
						label: 'Abarrotes',
					},
					distance: '3km',
					logo: '/static/images-new/logos/logo-store-default.png',
					name: 'Abarrotes Juanita',
				},
				{
					id: 8,
					address: 'Av. Abancay 456 Cercado de Lima',
					category: {
						id: 1,
						label: 'Abarrotes',
					},
					distance: '3km',
					logo: '/static/images-new/logos/logo-store-default.png',
					name: 'Abarrotes Juanita',
				},
				{
					id: 9,
					address: 'Av. Abancay 456 Cercado de Lima',
					category: {
						id: 1,
						label: 'Abarrotes',
					},
					distance: '3km',
					logo: '/static/images-new/logos/logo-store-default.png',
					name: 'Abarrotes Juanita',
				},
				{
					id: 10,
					address: 'Av. Abancay 456 Cercado de Lima',
					category: {
						id: 1,
						label: 'Abarrotes',
					},
					distance: '3km',
					logo: '/static/images-new/logos/logo-store-default.png',
					name: 'Abarrotes Juanita',
				},
				{
					id: 11,
					address: 'Av. Abancay 456 Cercado de Lima',
					category: {
						id: 1,
						label: 'Abarrotes',
					},
					distance: '3km',
					logo: '/static/images-new/logos/logo-store-default.png',
					name: 'Abarrotes Juanita',
				},
				{
					id: 12,
					address: 'Av. Abancay 456 Cercado de Lima',
					category: {
						id: 1,
						label: 'Abarrotes',
					},
					distance: '3km',
					logo: '/static/images-new/logos/logo-store-default.png',
					name: 'Abarrotes Juanita',
				},
			],
			userData: {},
			width: 100,
			unitHeight: '%',
			unitWidth: '%',
			zoom: 14,
		};
	}

	export default {
		name: 'page-commerce-view',
		components: {
			categoriesSelector,
			listView,
			gmapComponent,
			mapView,
			modalInformation,
		},
		computed: {
			dialogValue,
			displayMap,
		},
		created,
		data,
		methods: {
			activeLocation,
			changeLocation,
			loadData,
			loadLocations,
			onCenterChanged: debounce(onCenterChanged),
			onSwitchChange,
			saveLocation,
			selectedAll,
			selectedCategory,
			setAddress,
			setData,
			setLocation,
			visitStore,
		},
		watch: {
			location: {
				deep: true,
				handler: watchLocation,
			},
			locationInactive,
		},
	};
</script>

<style lang="scss" scoped>
.container-map {
	height: calc(100vh - 191px);
	position: absolute;
	top: 191px;
	width: 100%;
}

.vue-map-container {
	height: 100%;
	z-index: 1;
}

.dialog-market-place {
	.card {
		align-items: center;
		display: flex;
		height: 100% !important;
		justify-content: center;
		position: relative;
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/market-place/page-commerce-view.vue